import { Component, Prop, h } from '@stencil/core';
import { IImage } from '@ugc-components/ugc-pdp-review/interface';

@Component({
  tag: 'ugc-review-modal-images',
  shadow: false,
})
export class UgcReviewModalImages {
  @Prop() images: IImage[] = [];
  @Prop() handleClickImage: ({ assetId, reviewId, imageUrl }) => void;

  handleImageClick = item => {
    const { assetId, reviewId, paths: { l = '' } = {} } = item;
    this.handleClickImage({ assetId, reviewId, imageUrl: l });
  };

  render() {
    return (
      this.images.length > 0 && (
        <div class="flex-row-start-center mb-16 flex-wrap gap-4">
          {this.images.map(
            item =>
              item.paths &&
              item.paths.s && (
                <div
                  key={item.assetId}
                  class="ugc-overflow-hidden rounded-4 pointer"
                  style={{ flex: `0 0 80px`, height: '80px' }}
                  onClick={() => this.handleImageClick(item)}
                >
                  <img src={item.paths.s} alt="" style={{ width: '100%' }} />
                </div>
              )
          )}
        </div>
      )
    );
  }
}
